// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.report-home-page {
  padding-top: 50px;
}
.report-home-page .site-heading {
  font-size: 95px;
  text-transform: capitalize;
  color: #6e6e6e;
  font-weight: bold;
  font-family: "Conv_museo-500-webfont";
}
@media screen and (max-width: 991px) {
  .report-home-page .site-heading {
    font-size: 70px;
  }
}
@media only screen and (max-width: 767px) {
  .report-home-page .site-heading br {
    display: none;
  }
}
.report-home-page span.blue {
  color: rgb(0, 173, 208);
  font-size: 18px;
  text-transform: capitalize;
  font-weight: bold;
}
.report-home-page .site-logo img {
  font-weight: bold;
  max-width: 240px;
  width: 100%;
  height: auto;
}
.report-home-page-content {
  padding-top: 40px;
  font-size: 17px;
  text-transform: capitalize;
}
.report-home-page-content .left {
  color: rgb(105, 190, 40);
  font-weight: bold;
}
.report-home-page-content .left p {
  margin-bottom: 0;
}
.report-home-page-content .right {
  font-weight: 600;
}
.report-home-page-content .right p {
  margin-bottom: 20px;
}
.report-home-page-content .right span {
  color: #000;
  font-size: 20px;
  display: block;
  font-weight: bolder;
}
.report-home-page-content ul {
  margin: 20px 0;
  padding: 0px 10px;
  list-style-type: none;
}
.report-home-page-content ul li {
  display: inline-block;
  width: 40%;
  font-weight: 600;
  color: #6e6e6e;
}
.report-home-page-content ul li img {
  margin-right: 10px;
  width: 30px;
}
.report-home-page-content .height-box {
  min-height: 400px;
}
.report-home-page-footer .content {
  overflow: hidden;
  padding: 25px 16px;
  background: #6e6e6e;
}
.report-home-page-footer .content.bottom-text p {
  color: #fff;
}
.report-home-page-footer .content img {
  max-width: 120px;
  float: right;
}

@media screen and (max-width: 480px) {
  .report-top-section {
    width: 100% !important;
    text-align: center;
  }
}
.site-heading {
  font-size: 95px;
  text-transform: capitalize;
  color: #6e6e6e;
  font-weight: bold;
  font-family: "Conv_museo-500-webfont";
}
@media screen and (max-width: 991px) {
  .site-heading {
    font-size: 70px;
  }
}
@media screen and (max-width: 480px) {
  .site-heading {
    font-size: 55px;
  }
}

.site-logo img {
  font-weight: bold;
  max-width: 240px;
  width: 100%;
  height: auto;
}

.inline-list {
  padding-left: 0;
  list-style: none;
  padding-top: 5px;
}
.inline-list li {
  width: 33.33%;
  display: inline-block;
  margin-right: 0;
  height: 30px;
  margin-bottom: 20px;
}
@media screen and (max-width: 991px) {
  .inline-list li {
    width: 50%;
  }
}
@media screen and (max-width: 480px) {
  .inline-list li {
    width: 100%;
  }
}
.inline-list li .app-icon {
  display: inline-block !important;
  margin-right: 10px;
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .inline-list li .icon-txt {
    display: inline-block;
    max-width: 100px;
    vertical-align: top;
  }
}

.home-page-footer {
  background: #6d6e71;
  padding: 15px;
}

.home-page-footer .bottom-text p {
  color: #fff;
  display: inline-block;
  margin-bottom: 0;
  line-height: 28px;
}

.home-page-footer .bottom-text img {
  float: right;
  max-width: 20%;
}

.print-icon {
  margin-top: 25px;
  margin-right: 15px;
}
@media screen and (max-width: 767px) {
  .print-icon {
    margin-right: 0;
    top: 0;
    right: 9%;
    position: absolute;
  }
}

.report_admin__cell {
  border: 1px solid #d9d9d9;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/team-report/team-cover/team-cover.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AAtYA;EACC,iBAAA;AAyYD;AAtYC;EACC,eAAA;EACA,0BAAA;EACA,cAZS;EAaT,iBAAA;EACA,qCAXU;AAmZZ;AAvYE;EAND;IAOE,eAAA;EA0YD;AACF;AAxYE;EAEC;IACC,aAAA;EAyYF;AACF;AA9XC;EACC,uBDjBc;ECkBd,eAAA;EACA,0BAAA;EACA,iBAAA;AAgYF;AA1XE;EACC,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AA4XH;AAxXC;EACC,iBAAA;EACA,eAAA;EACA,0BAAA;AA0XF;AAzXE;EACC,wBDrCa;ECsCb,iBAAA;AA2XH;AA1XG;EACC,gBAAA;AA4XJ;AAtXE;EACC,gBAAA;AAwXH;AAvXG;EACC,mBAAA;AAyXJ;AAnXG;EACC,WAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAqXJ;AA/WE;EACC,cAAA;EACA,iBAAA;EACA,qBAAA;AAiXH;AAhXG;EACC,qBAAA;EACA,UAAA;EACA,gBAAA;EACA,cA7FO;AA+cX;AAjXI;EACC,kBAAA;EACA,WAAA;AAmXL;AArWE;EACC,iBAAA;AAuWH;AA5VE;EACC,gBAAA;EACG,kBAAA;EACA,mBA7HK;AA2dX;AA7VM;EACC,WD3DY;AC0ZnB;AA7VG;EACC,gBAAA;EACA,YAAA;AA+VJ;;AA1VA;EACE;IACI,sBAAA;IACA,kBAAA;EA6VJ;AACF;AA3VA;EACC,eAAA;EACA,0BAAA;EACA,cAjJU;EAkJV,iBAAA;EACA,qCAhJW;AA6eZ;AA3VC;EAPD;IAQE,eAAA;EA8VA;AACF;AA7VC;EAVD;IAWG,eAAA;EAgWD;AACF;;AA7VA;EACC,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAgWD;;AA9VA;EACC,eAAA;EACA,gBAAA;EACA,gBAAA;AAiWD;AAhWC;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AAkWD;AAjWC;EANA;IAOC,UAAA;EAoWA;AACF;AAnWC;EATA;IAUC,WAAA;EAsWA;AACF;AArWC;EACC,gCAAA;EACA,kBAAA;AAuWF;AArWC;EACC;IACI,qBAAA;IACA,gBAAA;IACA,mBAAA;EAuWJ;AACF;;AAjWA;EACC,mBD9JoB;EC+JjB,aAAA;AAoWJ;;AAjWA;EACC,WDpIkB;ECqIlB,qBAAA;EACA,gBAAA;EACG,iBAAA;AAoWJ;;AAjWA;EACC,YAAA;EACA,cAAA;AAoWD;;AAlWA;EACI,gBAAA;EACA,kBAAA;AAqWJ;AApWI;EAHJ;IAIK,eAAA;IACA,MAAA;IACA,SAAA;IACA,kBAAA;EAuWH;AACF;;AApWA;EACC,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;AAuWD","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","$site-width:800px;\n\n// Variables\n@import './../../../../assets/styles/variables';\n$bold-gray:#6e6e6e;\n$silver-gray:#77788b;\n\n$font-museo:'Conv_museo-500-webfont';\n// homepage\n.report-home-page {\n\tpadding-top:50px;\n\t\n\t\n\t.site-heading {\n\t\tfont-size: 95px;\n\t\ttext-transform: capitalize;\n\t\tcolor: $bold-gray;\n\t\tfont-weight: bold;\n\t\tfont-family:$font-museo;\n\t\t@media screen and (max-width: 991px){\n\t\t\tfont-size: 70px;\n\t\t}\n\n\t\t@media #{$mobile} {\n\n\t\t\tbr {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\n\t\t// @include screen (iphone-6s){\n\t\t// \tfont-size:50px;\n\t\t// }\n\n\t\t// @include screen (iphone-se){\n\t\t// \tfont-size:30px;\n\t\t// }\n\t}\n\tspan.blue {\n\t\tcolor:$clarify-color;\n\t\tfont-size:18px;\n\t\ttext-transform: capitalize;\n\t\tfont-weight: bold;\n\t\t// @include screen (iphone-se){\n\t\t// \tfont-size:15px;\n\t\t// }\n\t}\n\t.site-logo {\n\t\timg {\n\t\t\tfont-weight: bold;\n\t\t\tmax-width: 240px;\n\t\t\twidth: 100%;\n\t\t\theight: auto;\n\t\t}\n\t}\n\n\t&-content {\n\t\tpadding-top:40px;\n\t\tfont-size: 17px;\n\t\ttext-transform: capitalize;\n\t\t.left {\n\t\t\tcolor:$develop-color;\n\t\t\tfont-weight: bold;\n\t\t\tp {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\t// @include screen (iphone-se){\n\t\t\t\t// \tfont-size: 14px;\n\t\t\t\t// }\n\t\t\t}\n\t\t}\n\t\t.right {\n\t\t\tfont-weight: 600;\n\t\t\tp {\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t// @include screen (iphone-se){\n\t\t\t\t// \tfont-size: 14px;\n\t\t\t\t// \tmargin-bottom: 2px;\n\t\t\t\t// }\n\t\t\t}\n\t\t\tspan {\n\t\t\t\tcolor:#000;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tdisplay: block;\n\t\t\t\tfont-weight: bolder;\n\t\t\t\t// @include screen (iphone-se){\n\t\t\t\t// \tfont-size: 13px;\n\t\t\t\t// }\n\t\t\t}\n\t\t}\n\t\tul {\n\t\t\tmargin:20px 0;\n\t\t\tpadding:0px 10px;\n\t\t\tlist-style-type: none;\n\t\t\tli {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\twidth:40%;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tcolor: $bold-gray;\n\t\t\t\timg {\n\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\twidth:30px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t// @include screen (iphone-se){\n\t\t\t// \tpadding:0px;\n\t\t\t// \tli {\n\t\t\t// \t\twidth:48%;\n\t\t\t// \t\tfont-size: 13px;\n\t\t\t// \t\timg {\n\t\t\t// \t\t\tmargin-left: -14px;\n\t\t\t// \t\t}\n\t\t\t// \t}\n\t\t\t// }\n\t\t}\n\t\t.height-box {\n\t\t\tmin-height: 400px;\n\t\t\t// @include screen (iphone-6s){\n\t\t\t// \tmin-height: 200px;\n\t\t\t// }\n\t\t\t// @include screen (iphone-se){\n\t\t\t// \tmin-height: 50px;\n\t\t\t// }\n\t\t}\n\t}\n\n\t&-footer {\n\t\t.content {\n\t\t\toverflow: hidden;\n\t\t    padding: 25px 16px;\n\t\t    background: $bold-gray;\n\t\t   \t&.bottom-text p {\n\t\t   \t\tcolor:$color-light-type;\n\t\t   \t}\n\t\t\timg {\n\t\t\t\tmax-width: 120px;\n\t\t\t\tfloat:right;\n\t\t\t}\n\t\t}\n\t}\n}\n@media screen and (max-width: 480px){\n\t\t.report-top-section {\n\t\t    width: 100% !important;\n\t\t    text-align: center;\n\t\t}\n\t}\n.site-heading {\n\tfont-size: 95px;\n\ttext-transform: capitalize;\n\tcolor: $bold-gray;\n\tfont-weight: bold;\n\tfont-family:$font-museo;\n\t// padding-left: 150px;\n\t@media screen and (max-width: 991px){\n\t\tfont-size: 70px;\n\t}\n\t@media screen and (max-width: 480px){\n\t\t\tfont-size: 55px;\n\t\t}\n}\n\n.site-logo img{\n\tfont-weight: bold;\n\tmax-width: 240px;\n\twidth: 100%;\n\theight: auto;\n}\n.inline-list{\n\tpadding-left: 0;\n\tlist-style: none;\n\tpadding-top: 5px;\n\tli{\n\twidth: 33.33%;\n\tdisplay: inline-block;\n\tmargin-right: 0;\n\theight: 30px;\n\tmargin-bottom: 20px;\n\t@media screen and (max-width:991px){\n\t\twidth: 50%;\n\t}\n\t@media screen and (max-width:480px){\n\t\twidth: 100%;\n\t}\n\t.app-icon{\n\t\tdisplay: inline-block !important;\n\t\tmargin-right: 10px;\t\n\t}\n\t@media screen and (min-width: 768px) and (max-width:991px){\n\t\t.icon-txt {\n\t\t    display: inline-block;\n\t\t    max-width: 100px;\n\t\t    vertical-align: top;\n\t\t}\n\t}\n\t\n}\n\n} \n.home-page-footer{\n\tbackground: $color-neutral-dark;\n    padding: 15px;\n}\n\n.home-page-footer .bottom-text p{\n\tcolor: $color-light-type;\n\tdisplay:inline-block;\n\tmargin-bottom: 0;\n    line-height: 28px;\n}\n\n.home-page-footer .bottom-text img{\n\tfloat: right;\n\tmax-width: 20%;\n}\n.print-icon {\n    margin-top: 25px;\n    margin-right: 15px;\n    @media screen and (max-width: 767px){\n    \tmargin-right: 0;\n    \ttop: 0;\n    \tright: 9%;\n    \tposition: absolute;\n    }\n}\n\n.report_admin__cell {\n\tborder: 1px solid #d9d9d9;\n\tpadding: 20px;\n\tborder-radius: 10px;\n\tbox-shadow: 0 0 10px rgba(0,0,0,0.05);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
